// extracted by mini-css-extract-plugin
export var container = "badge-group-module--container--au03K";
export var link = "badge-group-module--link--s5sTp";
export var root = "badge-group-module--root--MYKj5";